import React, { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Filtro/selettore con ricerca digitabile. Le opzioni esistenti si cercano scrivendo;
// non crea nuove opzioni. options = [{value, label}].
export function SearchableSelect({
  value, onValueChange, options,
  placeholder = "Seleziona…", searchPlaceholder = "Cerca…", emptyText = "Nessun risultato",
  className, testId, width = "w-56", disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const selected = options.find((o) => o.value === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button disabled={disabled} variant="outline" role="combobox" aria-expanded={open}
          className={cn(width, "justify-between font-normal", className)} data-testid={testId}>
          <span className="truncate">{selected ? selected.label : placeholder}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className={cn(width, "p-0")} align="start">
        <Command>
          <CommandInput placeholder={searchPlaceholder} data-testid={testId ? `${testId}-search` : undefined} />
          <CommandList>
            <CommandEmpty>{emptyText}</CommandEmpty>
            <CommandGroup>
              {options.map((o) => (
                <CommandItem key={o.value} value={`${o.label} ${o.value}`}
                  onSelect={() => { onValueChange(o.value); setOpen(false); }}
                  data-testid={testId ? `${testId}-opt-${o.value}` : undefined}>
                  <Check className={cn("mr-2 h-4 w-4", value === o.value ? "opacity-100" : "opacity-0")} />
                  <span className="truncate">{o.label}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
